
import axios from "axios";
export const getGeo = () => {
    return axios.get("https://ipinfo.io/?token=2b467b9f1a28c0");
};
